import { Box, Image } from "@chakra-ui/react"
import sponsor from '../images/partner_e_sponsor.jpg'

const Sponsor = () => {
    return (
        <Box width={['98%', null, '820px', '1230px']} rounded='lg' mt={5}>
            <Image src={sponsor} rounded='lg' />

        </Box>

    )
}

export default Sponsor